let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Umxoq")).then(() => parcelRequire('5b8Rf'));